<template lang="pug">
    Row(type="flex" align="middle")
        Col(span="6") 
            pre {{ $t('global.select') }} {{ $t('domainsetting.groupName') }}
        Col(span="18")
            FormSelect(v-model="formData.groupName" :formData="formData"  :formItem="groupNameSelectorOptions" @input="$emit('updateGroupName', formData.groupName)")
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";

export default {
    name: "GroupListSelector",
    components: { FormSelect },
    props: {
        chooseGroupName: { type: [String, Array], default: ["", []] },
        multiple: { type: Boolean, default: false }
    },
    watch: {
        chooseGroupName: {
            deep: true,
            immediate: true,
            handler: function(val) {
                this.formData.groupName = val;
            }
        }
    },
    created() {},
    beforeDestroy() {},
    data() {
        return {
            formData: {
                groupName: this.chooseGroupName
            }
        };
    },

    methods: {},
    mounted() {},
    computed: {
        groupNameSelectorOptions() {
            return {
                placeholder: this.$i18n.t("domainsetting.groupName"),
                options: [],
                selectAllowCreate: false,
                multiple: this.multiple,
                clearable: true,
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.groupNames = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`groupnames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [],
                defaultVal: this.$store.state.queryGroupName == "all" ? "None" : this.$store.state.queryGroupName,
                disabled: this.$store.state.queryGroupName !== "all"
            };
        }
    }
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/GroupListSelector.vue